import { GroundStation } from '../types/groundStation';
import axiosAuth from 'common/AxiosAuth';

export async function fetchGroundStationList(): Promise<GroundStation[]> {
  const res = await axiosAuth.get('/api/groundstation/listAll');
  return res.data;
}

export async function fetchGroundStationDetail(id: number): Promise<GroundStation> {
  const res = await axiosAuth.get(`/api/groundstation/${id}`);
  return res.data;
} 